import React, { useEffect, useMemo } from 'react';
import { useForm } from '../../../Hooks/useForm';
import { Input, TableCell, TableRow } from 'semantic-ui-react';

const formatCurrency = value => `$${ Number( parseFloat( value ).toFixed( 2 ) ).toLocaleString( undefined, {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2
} ) }`;

const PlanRow = ( { plan, updatePlans } ) => {
	const { formData, updateField } = useForm( plan );

	useEffect( () => {
		updatePlans( plan.id, formData );
	}, [
		formData,
		plan.id,
		updatePlans
	] );

	const dollarChange = useMemo(
		() => plan.eE_Premium * plan.eE_Adj + plan.eS_Premium * plan.eS_Adj + plan.eC_Premium * plan.eC_Adj + plan.eF_Premium * plan.eF_Adj,
		[ plan ]
	);

	const projectedPremium = useMemo(
		() => dollarChange + plan.eE_Premium + plan.eS_Premium + plan.eC_Premium + plan.eF_Premium,
		[
			dollarChange,
			plan
		]
	);

	return (
		<TableRow key={ plan.id }>
			<TableCell>{ plan.planName }</TableCell>
			<TableCell style={{ minWidth: '100px' }}>
				<Input
					fluid
					name="eE_Adj"
					onChange={ updateField }
					value={ formData.eE_Adj }
				/>
			</TableCell>
			<TableCell style={{ minWidth: '100px' }}>
				<Input
					fluid
					name="eS_Adj"
					onChange={ updateField }
					value={ formData.eS_Adj }
				/>
			</TableCell>
			<TableCell style={{ minWidth: '100px' }}>
				<Input
					fluid
					name="eC_Adj"
					onChange={ updateField }
					value={ formData.eC_Adj }
				/>
			</TableCell>
			<TableCell style={{ minWidth: '100px' }}>
				<Input
					fluid
					name="eF_Adj"
					onChange={ updateField }
					value={ formData.eF_Adj }
				/>
			</TableCell>
			<TableCell>{ ( Number( plan.eE_Adj ) + Number( plan.eS_Adj ) + Number( plan.eC_Adj ) + Number( plan.eF_Adj ) ) / 4 }</TableCell>
			<TableCell>{ formatCurrency( projectedPremium ) }</TableCell>
			<TableCell>{ formatCurrency( dollarChange ) }</TableCell>
		</TableRow>
	);
};

export default PlanRow;
